<template>
  <v-dialog v-model="showEditQuote" width="1200" persistent>
    <v-card>
      <div id="queryHolder"></div>

      <v-banner sticky class="primary custom-padding py-0">
        <v-row class="text-left pb-0">
          <v-col cols="12" md="3" lg="2" class="py-0 pt-5">
            <span class="white--text custom-title">Quote Detail from NBN</span>
          </v-col>
          <v-col cols="12" md="4" lg="4" class="pb-0">
            <p class="white--text"></p>
          </v-col>
        </v-row>
      </v-banner>

      <ValidationObserver ref="observer" v-slot="{ dirty, invalid }">
        <v-card-text class="pt-0">
          <v-divider class="mt-4 mb-8"></v-divider>
            <v-textarea
              v-model="quoteDetail"
              placeholder=" "
              outlined
              dense
              :readonly="true"
            ></v-textarea>
        </v-card-text>

        <div class="text-right fixed-bar rtl primary py-4">
          <v-btn @click="closeQuery()" class="mr-4">Close</v-btn>
        </div>

        <div class="text-right fixed-bar rtl primary py-4">
          <v-btn @click="approveQuote()" class="mr-4" :disabled="!isPending">Approve Quote</v-btn>
        </div>
      </ValidationObserver>
    </v-card>
  </v-dialog>
</template>

<script>
import QuoteForm from "@/components/quoteManagement/quote-form";
export default {
  name: "edit-quote",
  props: {
    showEditQuote: { type: Boolean, required: true },
    quoteRecord:{type:String}
  },
  methods:{
    closeQuery() {
      let vm = this;
      document.getElementById("queryHolder").scrollIntoView({behavior: "smooth"});
      vm.$refs.observer.reset();
      vm.$emit("closeQuery");
    },
    approveQuote(){
      let vm =this;
      var payload = {
        quote:{
          eventNote:{
            code:"ACCA1401",
            reason:"RSP approval required for Fibre Build Category C to resume the quote."
          }
        },
        quoteID:vm.quoteRecord.quoteData.quoteId
      }
      vm.updateQuoteAsync(payload).then((data) => {
        vm.$emit("close", data);
      });
    }
  },
  computed:{
    quoteDetail(){
      let vm = this;
      var quoteJson = JSON.stringify(vm.quoteRecord.response.data, null, '\t');
      return quoteJson;
    },
    isPending(){
      let vm =this;
      if(vm.quoteRecord.quoteData.quoteType === "FbcQuote" && vm.quoteRecord.quoteData.status === "Pending")
      {
        return true;
      }else{
        return false;
      }
    }
  }
}
</script>

<style scoped>

</style>
